<template>
    <nuxt-link
        v-if="!isMounted || isMounted && !shouldResetCart(dispatchType) && !isCheckoutPath(route.path)"
        :href="getDispatchTypeUrl(dispatchType)"
        class="cursor-pointer"
        @click.prevent.stop="click(); resetCallback()"
    >
        <slot />
    </nuxt-link>
    <button
        v-else class="cursor-pointer"
        :disabled="disabled"
        type="button"
        @click.prevent.stop="click(); navigateToDispatchType(dispatchType, closeCallback, resetCallback)"
    >
        <slot />
    </button>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue'
    import type { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    import { getDispatchTypeUrl, navigateToDispatchType, shouldResetCart } from '~/composables/navigateToDispatchType'
    import { isCheckoutPath } from '~/utils/path-utils'
    defineProps({
        dispatchType: {
            type: String as PropType<DispatchTypeOrderBuddy>,
            required: true
        },
        click: {
            type: Function,
            default: () => Promise<void>
        },
        closeCallback: {
            type: Function,
            default: () => Promise<void>
        },
        resetCallback: {
            type: Function,
            default: () => Promise<void>
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })
    const route = useRoute()
    const isMounted = ref(false)
    onMounted(() => {
        isMounted.value = true
    })
</script>
